import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { StatusBadge } from '../../CaseStatus'
import ItemRemarks from '../ProfileCaseListItem/ItemRemarks'
import OpenForm from '../ProfileCaseListItem/OpenForm'
import caretRight from '../../icons/caret-right_light_gray.svg'
import caretRightActive from '../../icons/caret-right_gray.svg'
import { useI18nFunction } from '../I18n'
import { setActiveConnection, unsetActiveConnection } from '../../redux/actions'
import { getActiveConnectionDataFromClickedListItem } from '../ConnectionForm/utils'
import { getActiveConnection } from '../../redux/selectors'
import {
  USER_OWNERSHIP,
  PUBLIC_DATA_OWNERSHIP,
  RELATION_OWNERSHIP,
  RELATION_PUBLIC_DATA_OWNERSHIP,
} from '../../connectionTypes'
import GoToCase from '../ProfileCaseListItem/GoToCase'

const IndirectOwnershipListItem = ({
  Case,
  isRole,
  activeConnection,
  setActiveConnection,
  unsetActiveConnection,
  active,
  disabledInteraction,
  selectedCases,
  toggleCase
}) => {

  const I18nFunction = useI18nFunction()

  const getConnectionType = () => {
    if (Case?.userOwnership != null) {
      return USER_OWNERSHIP
    } else if (Case?.userPublicDataOwnership != null) {
      return PUBLIC_DATA_OWNERSHIP
    } else if (Case?.relationOwnership != null) {
      return RELATION_OWNERSHIP
    } else if (Case?.relationPublicDataOwnership != null) {
      return RELATION_PUBLIC_DATA_OWNERSHIP
    }
  }

  const connectionType = getConnectionType()
  const checked = [USER_OWNERSHIP, RELATION_OWNERSHIP].includes(connectionType)

  const onClick = (e) => {
    const activeConnectionData = getActiveConnectionDataFromClickedListItem(
      Case,
    )

    unsetActiveConnection()
    active
      ? unsetActiveConnection()
      : setActiveConnection({
        id: activeConnectionData.id,
        caseId: Case?.id,
        relationId: Case?.relationId,
        connectionType: connectionType,
        directConnectionCaseId: Case?.directConnectionCaseId,
        parentCaseId: Case?.parentCaseId,
        connection: activeConnectionData,
      })
  }

  const getSharePercentage = () => {
    const ownershipData =
      Case.userOwnership || Case.userPublicDataOwnership || Case.relationOwnership || Case.relationPublicDataOwnership
    if (ownershipData?.stakePercentage != null) {
      return I18nFunction({
        id: 'share_percentage',
        share: parseFloat(ownershipData.stakePercentage).toFixed(2)
      })
    }
    else {
      return ""
    }
  }

  return (
    <li>
      <Wrapper>
        {!disabledInteraction &&
          <ToggleWrapper>
            <input
              type="checkbox"
              checked={!!selectedCases[Case.id]}
              onChange={() => {
                toggleCase(Case.id)
                unsetActiveConnection()
              }}
            />
          </ToggleWrapper>
        }
        <CaseNumber>
          #{Case.id}
        </CaseNumber>
        <Description className={[
          active && 'active',
          !checked && 'attention',
          !!selectedCases[Case.id] && 'toggled',
          disabledInteraction && 'disabledInteraction',
        ]}
          onClick={onClick}>
          <Organization>
            <Title small={true} title={Case?.organizationName}>
              {Case?.organizationName}
            </Title>
            <Subtitle>
              {Case?.organizationNumber}
            </Subtitle>
            <StakePercentage>
              {!isRole && getSharePercentage()}
            </StakePercentage>
          </Organization>
          <RightFlexBox>
            <StatusWrapper>
              <StatusBadge status={Case?.status} />
            </StatusWrapper>
            <MarkerWrapper>
              <ItemRemarks Case={Case} confirmed={checked} />
            </MarkerWrapper>
            <Buttons>
              {checked && <GoToCase caseId={Case?.id} />}
              <OpenForm onClick={onClick} />
              <CaretRight src={active ? caretRightActive : caretRight} />
            </Buttons>
          </RightFlexBox>
        </Description>
      </Wrapper>
    </li>
  )
}

const Wrapper = styled.div`
  min-width: 100%;
  position: relative;
  display: flex;
  align-items: center;
`

const ToggleWrapper = styled.div`
  display: flex;
  width: 4%;
  align-items: center;
`

const CaseNumber = styled.div`
  width: 9%
  color: ${({ theme: { subtleText } }) => subtleText};  
`

const Description = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 87%;
  box-shadow: rgb(219 219 219) 0px 2px 5px;
  background-color: ${({ theme }) => theme.primaryBackground};
  padding: 0.8em;
  padding-left: 1em;
  padding-right: 1em;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.listItemHover};
  }

  &.active {
    background-color: ${({ theme }) => theme.listItemHover};
  }
  &.attention {
  }
  &.disabledInteraction {
    background-color: ${({ theme }) => theme.pageBackground};
  }
`

const Organization = styled.div`
  overflow: hidden;
  white-space: nowrap;
  width: 34%;
  padding-right: 0em;
`

const Title = styled.div`
  font-size: ${({ small, theme: { normalText, largeText } }) =>
    small ? normalText : largeText};
  ${({ title, theme: { secondary } }) => !title && 'color: ' + secondary}
  margin-bottom: 0.2em;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Subtitle = styled.div`
  display: flex;
  flex-direction: row;
  color: ${({ theme: { subtleText } }) => subtleText};

`

const StakePercentage = styled.div`
  width: 15%;
  display: flex;
  align-items: left;
  justify-content: space-around;
`

const RightFlexBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 60%;
`

const StatusWrapper = styled.div`
  display: flex;
`

const MarkerWrapper = styled.div`
  margin-left: auto; 
  margin-right: 0;
`

const Buttons = styled.div`
  display: flex;
  margin-left: auto; 
  margin-right: 0;
  gap: 0.2em;
  padding: 0em 0.5em;
`

const CaretRight = styled.img`
`

const mapStateToProps = (state, props) => {
  const activeConnection = getActiveConnection(state)
  const active = (activeConnection?.caseId === props.Case.id)

  return {
    active: active,
    activeConnection: activeConnection
  }
}

const mapDispatchToProps = { setActiveConnection, unsetActiveConnection }

export default connect(mapStateToProps, mapDispatchToProps)(IndirectOwnershipListItem)

